// The free lesson and cheat sheet pages (web/lesson.html, written by the server at /lessons and /sheets): their
// styles, the quiz checked as you pick (no AI, as in the app), and Start free with Google, which opens the page the
// button names (data-next, a cheat sheet in the app). The words are already in the page.
import '@fontsource/atkinson-hyperlegible/400.css';
import '@fontsource/atkinson-hyperlegible/700.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './features/waitlist/waitlist.css';
import './features/sheets/sheets.css';
import './features/tutorials/tutorials.css';
import { startGoogleSignIn } from './features/auth/data';

// Lucide's check and x, as the app's Option shows them.
const mark = (label: string, paths: string) =>
  `<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="${label}">${paths}</svg>`;
const RIGHT = mark('Right', '<path d="M20 6 9 17l-5-5"/>');
const WRONG = mark('Wrong', '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>');

const questions = [...document.querySelectorAll<HTMLElement>('[data-question]')];
const score = document.querySelector<HTMLElement>('[data-score]');
let right = 0;
let answered = 0;
for (const q of questions) {
  const answer = Number(q.dataset.answer);
  const options = [...q.querySelectorAll<HTMLButtonElement>('.option')];
  options.forEach((option, n) => {
    option.addEventListener('click', () => {
      if (q.dataset.picked) return;
      q.dataset.picked = 'yes';
      option.setAttribute('aria-pressed', 'true');
      options[answer]?.classList.add('right');
      options[answer]?.insertAdjacentHTML('beforeend', RIGHT);
      if (n === answer) right++;
      else {
        option.classList.add('wrong');
        option.insertAdjacentHTML('beforeend', WRONG);
      }
      answered++;
      if (score && answered === questions.length) score.textContent = `${right} of ${questions.length} right.`;
    });
  });
}

// A start that fails opens sign-in, which says so (as on the home page).
for (const button of document.querySelectorAll<HTMLButtonElement>('[data-start]')) {
  button.addEventListener('click', async () => {
    button.disabled = true;
    button.textContent = 'Opening Google';
    try {
      await startGoogleSignIn(button.dataset.next);
    } catch {
      window.location.assign('/signin?error=start_failed');
    }
  });
}
